import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { EasyNotificationService, NotifyMessage } from 'src/app/services/easy-notification.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { delay } from 'src/app/shared/utilities';

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.css']
})
export class NotifyComponent implements OnInit {

 /** 新訊息接收到的呈現方式 當樣式開啟為Left開頭時 */
 displayMode:{
   In:'slide-in'|'slide-in2'|'slide-in3',
   Idle:'idle'|'idle2'|'idle3',
   Out:'slide-out'|'slide-out2'|'slide-out3'
 } = {
   In:'slide-in',
   Idle:'idle',
   Out:'slide-out'
 }
 msg:NotifyMessage;
 msg2:NotifyMessage;
 msgQ:NotifyMessage[] = []
 async isSupportedMode(){
   var mode = (await this.clinicData.getParam('SYS101')).NotifyPosition;
   return ['right','right2left','topest'].includes(mode)
 }
 constructor(private notify:EasyNotificationService,
   private clinicData:ClinicDataService
 ) {
 
   notify.OnMessage.subscribe(async x=>{
     
     if(await this.isSupportedMode()){
       this.msgQ.push(x);
       if(!this.msg && !this.msg2){
         this.showMsg()
       }else{
         // 舊的移除等待 直接退場在顯示下一個
         this.closeMsg()
       }
     }
   });
 }

 async ngOnInit() {
   this.clinicData.onPreload.subscribe(async ()=>{
     await this.updateNotifyMode()
   });
   this.clinicData.onReload.subscribe(async ()=>{
     await this.updateNotifyMode()
   });
   this.clinicData.onParamChanged.subscribe(async n=>{
     if(n.some(x=>x=='SYS101')){
       await this.updateNotifyMode();
     }
   })
 }
 async updateNotifyMode(){
   var sys101 = await this.clinicData.getParam('SYS101')
   
   var pos = sys101.NotifyPosition;
   if(pos =='right'){
     this.displayMode.In = 'slide-in'
     this.displayMode.Idle = 'idle';
     this.displayMode.Out = 'slide-out'
   }else if(pos =='right2left'){
     this.displayMode.In = 'slide-in2'
     this.displayMode.Idle = 'idle2';
     this.displayMode.Out = 'slide-out2'
   }else if(pos =='topest'){
     this.displayMode.In = 'slide-in3'
     this.displayMode.Idle = 'idle3';
     this.displayMode.Out = 'slide-out3'
   }
   
   
 }
 @ViewChild('msgdiv')
 msgdiv:ElementRef<HTMLDivElement>
 @ViewChild('msgdiv2')
 msgdiv2:ElementRef<HTMLDivElement>
 msg2slideOutTimeout = null;
 async showMsg(){
   if(this.msgQ.length==0){
     return;
   }
   
   var m = this.msgQ.splice(0,1)[0]
   this.msg = m;
   // 雙向綁定進場css class來觸發動畫
 }
 async closeMsg(){
   //舊的直接退場
   if(this.msgdiv2){
     if(this.msg2slideOutTimeout){
       clearTimeout(this.msg2slideOutTimeout)
       this.msg2slideOutTimeout = null;
     }
     this.msgdiv2.nativeElement.classList.add(this.displayMode.Out)
     await delay(500);
   }
 }
 async onMsg1ShowEnd(){
   this.msg2 = this.msg;
   this.msg = null;
   // 隔N秒退場
   await delay(0)
   // 標準位置
   this.msgdiv2.nativeElement.classList.add(this.displayMode.Idle)
   var delayMs = this.msgQ.length>0?500:3000;
   this.msg2slideOutTimeout = setTimeout(() => {
     //退場動畫
     this.msgdiv2.nativeElement.classList.add(this.displayMode.Out)
     this.msg2slideOutTimeout = null;
   }, delayMs);
 }
 async onMsg2ShowEnd(){
   this.msg2 = null;
   await delay(100)
   //消化下一個
   await this.showMsg()
 }
}
